"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.small.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _get_date = _interopRequireDefault(require("date-fns/get_date"));
var _gridStyled = require("grid-styled");
var _polished = require("polished");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _get = _interopRequireDefault(require("lodash/get"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _utils2 = require("./utils");
var _jsxFileName = "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/Day.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _templateObject16,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1jry2mt7kl() {
  var path = "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/Day.js";
  var hash = "6ac7e72aa1ee825a0cf6c984ac9c7f38ddc5786a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/Day.js",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 41
        },
        end: {
          line: 16,
          column: 57
        }
      },
      "1": {
        start: {
          line: 19,
          column: 15
        },
        end: {
          line: 135,
          column: 1
        }
      },
      "2": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 37,
          column: 7
        }
      },
      "3": {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 44,
          column: 7
        }
      },
      "4": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 70,
          column: 52
        }
      },
      "5": {
        start: {
          line: 73,
          column: 17
        },
        end: {
          line: 73,
          column: 59
        }
      },
      "6": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 88
        }
      },
      "7": {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 88,
          column: 7
        }
      },
      "8": {
        start: {
          line: 93,
          column: 35
        },
        end: {
          line: 93,
          column: 80
        }
      },
      "9": {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 101,
          column: 9
        }
      },
      "10": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 109,
          column: 7
        }
      },
      "11": {
        start: {
          line: 113,
          column: 8
        },
        end: {
          line: 120,
          column: 9
        }
      },
      "12": {
        start: {
          line: 122,
          column: 17
        },
        end: {
          line: 122,
          column: 59
        }
      },
      "13": {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 132,
          column: 9
        }
      },
      "14": {
        start: {
          line: 137,
          column: 18
        },
        end: {
          line: 198,
          column: 1
        }
      },
      "15": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 147,
          column: 7
        }
      },
      "16": {
        start: {
          line: 149,
          column: 8
        },
        end: {
          line: 153,
          column: 51
        }
      },
      "17": {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 165,
          column: 7
        }
      },
      "18": {
        start: {
          line: 175,
          column: 17
        },
        end: {
          line: 182,
          column: 7
        }
      },
      "19": {
        start: {
          line: 200,
          column: 19
        },
        end: {
          line: 208,
          column: 2
        }
      },
      "20": {
        start: {
          line: 203,
          column: 49
        },
        end: {
          line: 203,
          column: 102
        }
      },
      "21": {
        start: {
          line: 206,
          column: 15
        },
        end: {
          line: 206,
          column: 69
        }
      },
      "22": {
        start: {
          line: 210,
          column: 28
        },
        end: {
          line: 212,
          column: 1
        }
      },
      "23": {
        start: {
          line: 214,
          column: 21
        },
        end: {
          line: 226,
          column: 1
        }
      },
      "24": {
        start: {
          line: 218,
          column: 4
        },
        end: {
          line: 219,
          column: 17
        }
      },
      "25": {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 222,
          column: 23
        }
      },
      "26": {
        start: {
          line: 228,
          column: 19
        },
        end: {
          line: 235,
          column: 1
        }
      },
      "27": {
        start: {
          line: 237,
          column: 18
        },
        end: {
          line: 239,
          column: 4
        }
      },
      "28": {
        start: {
          line: 241,
          column: 16
        },
        end: {
          line: 243,
          column: 1
        }
      },
      "29": {
        start: {
          line: 245,
          column: 18
        },
        end: {
          line: 257,
          column: 2
        }
      },
      "30": {
        start: {
          line: 248,
          column: 15
        },
        end: {
          line: 255,
          column: 7
        }
      },
      "31": {
        start: {
          line: 262,
          column: 12
        },
        end: {
          line: 290,
          column: 1
        }
      },
      "32": {
        start: {
          line: 263,
          column: 2
        },
        end: {
          line: 289,
          column: 11
        }
      },
      "33": {
        start: {
          line: 292,
          column: 0
        },
        end: {
          line: 309,
          column: 2
        }
      },
      "34": {
        start: {
          line: 311,
          column: 0
        },
        end: {
          line: 319,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 26,
            column: 9
          }
        },
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 37,
            column: 7
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 38,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        },
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        },
        line: 40
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        },
        loc: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 70,
            column: 52
          }
        },
        line: 47
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        },
        loc: {
          start: {
            line: 73,
            column: 17
          },
          end: {
            line: 73,
            column: 59
          }
        },
        line: 73
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 74,
            column: 22
          },
          end: {
            line: 74,
            column: 23
          }
        },
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 88
          }
        },
        line: 75
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 77,
            column: 9
          }
        },
        loc: {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 88,
            column: 7
          }
        },
        line: 79
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 93,
            column: 26
          },
          end: {
            line: 93,
            column: 27
          }
        },
        loc: {
          start: {
            line: 93,
            column: 35
          },
          end: {
            line: 93,
            column: 80
          }
        },
        line: 93
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 96,
            column: 9
          }
        },
        loc: {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        },
        line: 98
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 103,
            column: 9
          }
        },
        loc: {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 109,
            column: 7
          }
        },
        line: 105
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 111,
            column: 9
          }
        },
        loc: {
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        },
        line: 113
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 122,
            column: 9
          }
        },
        loc: {
          start: {
            line: 122,
            column: 17
          },
          end: {
            line: 122,
            column: 59
          }
        },
        line: 122
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 124,
            column: 9
          }
        },
        loc: {
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        },
        line: 126
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 143,
            column: 9
          }
        },
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 147,
            column: 7
          }
        },
        line: 144
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 148,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        },
        loc: {
          start: {
            line: 149,
            column: 8
          },
          end: {
            line: 153,
            column: 51
          }
        },
        line: 149
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 154,
            column: 8
          },
          end: {
            line: 154,
            column: 9
          }
        },
        loc: {
          start: {
            line: 155,
            column: 8
          },
          end: {
            line: 165,
            column: 7
          }
        },
        line: 155
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 175,
            column: 8
          },
          end: {
            line: 175,
            column: 9
          }
        },
        loc: {
          start: {
            line: 175,
            column: 17
          },
          end: {
            line: 182,
            column: 7
          }
        },
        line: 175
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 203,
            column: 39
          },
          end: {
            line: 203,
            column: 40
          }
        },
        loc: {
          start: {
            line: 203,
            column: 49
          },
          end: {
            line: 203,
            column: 102
          }
        },
        line: 203
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 206,
            column: 6
          },
          end: {
            line: 206,
            column: 7
          }
        },
        loc: {
          start: {
            line: 206,
            column: 15
          },
          end: {
            line: 206,
            column: 69
          }
        },
        line: 206
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 217,
            column: 11
          },
          end: {
            line: 217,
            column: 12
          }
        },
        loc: {
          start: {
            line: 218,
            column: 4
          },
          end: {
            line: 219,
            column: 17
          }
        },
        line: 218
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 220,
            column: 22
          },
          end: {
            line: 220,
            column: 23
          }
        },
        loc: {
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 222,
            column: 23
          }
        },
        line: 221
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 248,
            column: 6
          },
          end: {
            line: 248,
            column: 7
          }
        },
        loc: {
          start: {
            line: 248,
            column: 15
          },
          end: {
            line: 255,
            column: 7
          }
        },
        line: 248
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 262,
            column: 12
          },
          end: {
            line: 262,
            column: 13
          }
        },
        loc: {
          start: {
            line: 263,
            column: 2
          },
          end: {
            line: 289,
            column: 11
          }
        },
        line: 263
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 37,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 20
          }
        }, {
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 37,
            column: 7
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 30,
            column: 26
          },
          end: {
            line: 34,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 26
          },
          end: {
            line: 30,
            column: 31
          }
        }, {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 17
          }
        }, {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 32,
            column: 26
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 45
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 59
          }
        }],
        line: 30
      },
      "2": {
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 20
          }
        }, {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 41,
            column: 19
          }
        }, {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        }],
        line: 40
      },
      "3": {
        loc: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 70,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 20
          }
        }, {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 18
          }
        }, {
          start: {
            line: 49,
            column: 6
          },
          end: {
            line: 70,
            column: 52
          }
        }],
        line: 47
      },
      "4": {
        loc: {
          start: {
            line: 59,
            column: 33
          },
          end: {
            line: 62,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 33
          },
          end: {
            line: 59,
            column: 38
          }
        }, {
          start: {
            line: 60,
            column: 12
          },
          end: {
            line: 60,
            column: 23
          }
        }, {
          start: {
            line: 61,
            column: 12
          },
          end: {
            line: 61,
            column: 32
          }
        }, {
          start: {
            line: 62,
            column: 12
          },
          end: {
            line: 62,
            column: 51
          }
        }],
        line: 59
      },
      "5": {
        loc: {
          start: {
            line: 67,
            column: 28
          },
          end: {
            line: 70,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 28
          },
          end: {
            line: 67,
            column: 33
          }
        }, {
          start: {
            line: 68,
            column: 10
          },
          end: {
            line: 68,
            column: 21
          }
        }, {
          start: {
            line: 69,
            column: 10
          },
          end: {
            line: 69,
            column: 30
          }
        }, {
          start: {
            line: 70,
            column: 10
          },
          end: {
            line: 70,
            column: 49
          }
        }],
        line: 67
      },
      "6": {
        loc: {
          start: {
            line: 73,
            column: 17
          },
          end: {
            line: 73,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 73,
            column: 17
          },
          end: {
            line: 73,
            column: 29
          }
        }, {
          start: {
            line: 73,
            column: 33
          },
          end: {
            line: 73,
            column: 59
          }
        }],
        line: 73
      },
      "7": {
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 13
          }
        }, {
          start: {
            line: 75,
            column: 17
          },
          end: {
            line: 75,
            column: 28
          }
        }, {
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 52
          }
        }, {
          start: {
            line: 75,
            column: 56
          },
          end: {
            line: 75,
            column: 88
          }
        }],
        line: 75
      },
      "8": {
        loc: {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 88,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 79,
            column: 23
          }
        }, {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 88,
            column: 7
          }
        }],
        line: 79
      },
      "9": {
        loc: {
          start: {
            line: 83,
            column: 30
          },
          end: {
            line: 86,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 30
          },
          end: {
            line: 83,
            column: 35
          }
        }, {
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 84,
            column: 23
          }
        }, {
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 85,
            column: 32
          }
        }, {
          start: {
            line: 86,
            column: 12
          },
          end: {
            line: 86,
            column: 51
          }
        }],
        line: 83
      },
      "10": {
        loc: {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 98,
            column: 22
          }
        }, {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        }],
        line: 98
      },
      "11": {
        loc: {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 109,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 105,
            column: 22
          }
        }, {
          start: {
            line: 106,
            column: 8
          },
          end: {
            line: 106,
            column: 21
          }
        }, {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 109,
            column: 7
          }
        }],
        line: 105
      },
      "12": {
        loc: {
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 113,
            column: 22
          }
        }, {
          start: {
            line: 114,
            column: 8
          },
          end: {
            line: 114,
            column: 20
          }
        }, {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        }],
        line: 113
      },
      "13": {
        loc: {
          start: {
            line: 122,
            column: 17
          },
          end: {
            line: 122,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 17
          },
          end: {
            line: 122,
            column: 29
          }
        }, {
          start: {
            line: 122,
            column: 33
          },
          end: {
            line: 122,
            column: 59
          }
        }],
        line: 122
      },
      "14": {
        loc: {
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 126,
            column: 23
          }
        }, {
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        }],
        line: 126
      },
      "15": {
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 147,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 144,
            column: 20
          }
        }, {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 147,
            column: 7
          }
        }],
        line: 144
      },
      "16": {
        loc: {
          start: {
            line: 149,
            column: 8
          },
          end: {
            line: 153,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 149,
            column: 8
          },
          end: {
            line: 149,
            column: 22
          }
        }, {
          start: {
            line: 150,
            column: 8
          },
          end: {
            line: 153,
            column: 51
          }
        }],
        line: 149
      },
      "17": {
        loc: {
          start: {
            line: 150,
            column: 18
          },
          end: {
            line: 153,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 150,
            column: 18
          },
          end: {
            line: 150,
            column: 23
          }
        }, {
          start: {
            line: 151,
            column: 10
          },
          end: {
            line: 151,
            column: 21
          }
        }, {
          start: {
            line: 152,
            column: 10
          },
          end: {
            line: 152,
            column: 30
          }
        }, {
          start: {
            line: 153,
            column: 10
          },
          end: {
            line: 153,
            column: 49
          }
        }],
        line: 150
      },
      "18": {
        loc: {
          start: {
            line: 155,
            column: 8
          },
          end: {
            line: 165,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 155,
            column: 8
          },
          end: {
            line: 155,
            column: 21
          }
        }, {
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 165,
            column: 7
          }
        }],
        line: 155
      },
      "19": {
        loc: {
          start: {
            line: 157,
            column: 30
          },
          end: {
            line: 160,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 30
          },
          end: {
            line: 157,
            column: 35
          }
        }, {
          start: {
            line: 158,
            column: 12
          },
          end: {
            line: 158,
            column: 23
          }
        }, {
          start: {
            line: 159,
            column: 12
          },
          end: {
            line: 159,
            column: 32
          }
        }, {
          start: {
            line: 160,
            column: 12
          },
          end: {
            line: 160,
            column: 54
          }
        }],
        line: 157
      },
      "20": {
        loc: {
          start: {
            line: 161,
            column: 19
          },
          end: {
            line: 164,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 161,
            column: 19
          },
          end: {
            line: 161,
            column: 24
          }
        }, {
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 162,
            column: 23
          }
        }, {
          start: {
            line: 163,
            column: 12
          },
          end: {
            line: 163,
            column: 32
          }
        }, {
          start: {
            line: 164,
            column: 12
          },
          end: {
            line: 164,
            column: 56
          }
        }],
        line: 161
      },
      "21": {
        loc: {
          start: {
            line: 175,
            column: 17
          },
          end: {
            line: 182,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 175,
            column: 17
          },
          end: {
            line: 175,
            column: 30
          }
        }, {
          start: {
            line: 175,
            column: 34
          },
          end: {
            line: 182,
            column: 7
          }
        }],
        line: 175
      },
      "22": {
        loc: {
          start: {
            line: 203,
            column: 49
          },
          end: {
            line: 203,
            column: 102
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 203,
            column: 64
          },
          end: {
            line: 203,
            column: 97
          }
        }, {
          start: {
            line: 203,
            column: 100
          },
          end: {
            line: 203,
            column: 102
          }
        }],
        line: 203
      },
      "23": {
        loc: {
          start: {
            line: 206,
            column: 15
          },
          end: {
            line: 206,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 206,
            column: 32
          },
          end: {
            line: 206,
            column: 64
          }
        }, {
          start: {
            line: 206,
            column: 67
          },
          end: {
            line: 206,
            column: 69
          }
        }],
        line: 206
      },
      "24": {
        loc: {
          start: {
            line: 218,
            column: 4
          },
          end: {
            line: 219,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 218,
            column: 5
          },
          end: {
            line: 218,
            column: 16
          }
        }, {
          start: {
            line: 218,
            column: 20
          },
          end: {
            line: 218,
            column: 40
          }
        }, {
          start: {
            line: 218,
            column: 44
          },
          end: {
            line: 218,
            column: 83
          }
        }, {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 219,
            column: 17
          }
        }],
        line: 218
      },
      "25": {
        loc: {
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 222,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 221,
            column: 5
          },
          end: {
            line: 221,
            column: 16
          }
        }, {
          start: {
            line: 221,
            column: 20
          },
          end: {
            line: 221,
            column: 40
          }
        }, {
          start: {
            line: 221,
            column: 44
          },
          end: {
            line: 221,
            column: 81
          }
        }, {
          start: {
            line: 222,
            column: 4
          },
          end: {
            line: 222,
            column: 23
          }
        }],
        line: 221
      },
      "26": {
        loc: {
          start: {
            line: 248,
            column: 15
          },
          end: {
            line: 255,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 248,
            column: 15
          },
          end: {
            line: 248,
            column: 28
          }
        }, {
          start: {
            line: 248,
            column: 32
          },
          end: {
            line: 255,
            column: 7
          }
        }],
        line: 248
      },
      "27": {
        loc: {
          start: {
            line: 264,
            column: 7
          },
          end: {
            line: 264,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 264,
            column: 22
          },
          end: {
            line: 264,
            column: 27
          }
        }, {
          start: {
            line: 264,
            column: 30
          },
          end: {
            line: 264,
            column: 31
          }
        }],
        line: 264
      },
      "28": {
        loc: {
          start: {
            line: 271,
            column: 9
          },
          end: {
            line: 271,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 271,
            column: 9
          },
          end: {
            line: 271,
            column: 24
          }
        }, {
          start: {
            line: 271,
            column: 28
          },
          end: {
            line: 271,
            column: 74
          }
        }],
        line: 271
      },
      "29": {
        loc: {
          start: {
            line: 273,
            column: 7
          },
          end: {
            line: 273,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 273,
            column: 7
          },
          end: {
            line: 273,
            column: 19
          }
        }, {
          start: {
            line: 273,
            column: 23
          },
          end: {
            line: 273,
            column: 97
          }
        }],
        line: 273
      },
      "30": {
        loc: {
          start: {
            line: 274,
            column: 7
          },
          end: {
            line: 283,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 274,
            column: 7
          },
          end: {
            line: 274,
            column: 20
          }
        }, {
          start: {
            line: 275,
            column: 8
          },
          end: {
            line: 282,
            column: 21
          }
        }],
        line: 274
      },
      "31": {
        loc: {
          start: {
            line: 285,
            column: 5
          },
          end: {
            line: 287,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 285,
            column: 5
          },
          end: {
            line: 285,
            column: 39
          }
        }, {
          start: {
            line: 286,
            column: 6
          },
          end: {
            line: 286,
            column: 98
          }
        }],
        line: 285
      },
      "32": {
        loc: {
          start: {
            line: 285,
            column: 7
          },
          end: {
            line: 285,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 285,
            column: 7
          },
          end: {
            line: 285,
            column: 21
          }
        }, {
          start: {
            line: 285,
            column: 25
          },
          end: {
            line: 285,
            column: 38
          }
        }],
        line: 285
      },
      "33": {
        loc: {
          start: {
            line: 288,
            column: 5
          },
          end: {
            line: 288,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 288,
            column: 5
          },
          end: {
            line: 288,
            column: 20
          }
        }, {
          start: {
            line: 288,
            column: 24
          },
          end: {
            line: 288,
            column: 61
          }
        }],
        line: 288
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0, 0, 0],
      "2": [0, 0, 0],
      "3": [0, 0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0, 0, 0],
      "6": [0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0, 0],
      "18": [0, 0],
      "19": [0, 0, 0, 0],
      "20": [0, 0, 0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0, 0, 0],
      "25": [0, 0, 0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6ac7e72aa1ee825a0cf6c984ac9c7f38ddc5786a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1jry2mt7kl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1jry2mt7kl();
var _ref = (cov_1jry2mt7kl().s[0]++, _stylingConstants.default),
  color = _ref.color,
  border = _ref.border,
  spacing = _ref.spacing,
  font = _ref.font;

// put border on the top left for the containder and for object inside
var BoxDay = (cov_1jry2mt7kl().s[1]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: "g-calendar-day"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      ", "\n      ", "\n      ", "\n      border-width: 0 ", " ", " 0;\n      border-style: solid;\n      ", "\n      border-color: ", ";\n\n      ", "\n    "])), function (props) {
  cov_1jry2mt7kl().f[0]++;
  cov_1jry2mt7kl().s[2]++;
  return (
    // if disabled show a darker color
    (cov_1jry2mt7kl().b[0][0]++, props.disabled) && (cov_1jry2mt7kl().b[0][1]++, "\n      background-color: ".concat((cov_1jry2mt7kl().b[1][0]++, props) && (cov_1jry2mt7kl().b[1][1]++, props.theme) && (cov_1jry2mt7kl().b[1][2]++, props.theme.calendar) && (cov_1jry2mt7kl().b[1][3]++, props.theme.calendar.disabledDayBgColor) && (cov_1jry2mt7kl().b[1][4]++, (0, _polished.lighten)(0.1, props.theme.calendar.disabledDayBgColor)), ";\n\n      color: ").concat(color.disabledText, ";\n      "))
  );
}, function (props) {
  cov_1jry2mt7kl().f[1]++;
  cov_1jry2mt7kl().s[3]++;
  return (
    // in small view, hide sisable days
    (cov_1jry2mt7kl().b[2][0]++, props.disabled) && (cov_1jry2mt7kl().b[2][1]++, !props.bigday) && (cov_1jry2mt7kl().b[2][2]++, "\n        display:none;\n      ")
  );
}, function (props) {
  cov_1jry2mt7kl().f[2]++;
  cov_1jry2mt7kl().s[4]++;
  return (
    // show selected color
    (cov_1jry2mt7kl().b[3][0]++, props.selected) && (cov_1jry2mt7kl().b[3][1]++, props.bigday) && (cov_1jry2mt7kl().b[3][2]++, "\n\n        &:after {\n          right: 50%;\n          border: solid transparent;\n          content: ' ';\n          height: 0;\n          width: 0;\n          position: absolute;\n          pointer-events: none;\n          border-bottom-color: ".concat((cov_1jry2mt7kl().b[4][0]++, props) && (cov_1jry2mt7kl().b[4][1]++, props.theme) && (cov_1jry2mt7kl().b[4][2]++, props.theme.calendar) && (cov_1jry2mt7kl().b[4][3]++, props.theme.calendar.detailedDayBgColor), ";\n          border-width: 1rem;\n          margin-right: -1rem;\n          bottom:0px;\n        }\n        background-color: ").concat((cov_1jry2mt7kl().b[5][0]++, props) && (cov_1jry2mt7kl().b[5][1]++, props.theme) && (cov_1jry2mt7kl().b[5][2]++, props.theme.calendar) && (cov_1jry2mt7kl().b[5][3]++, props.theme.calendar.selectedDayBgColor), ";"))
  );
}, border.widthBase, border.widthBase, function (props) {
  cov_1jry2mt7kl().f[3]++;
  cov_1jry2mt7kl().s[5]++;
  return (cov_1jry2mt7kl().b[6][0]++, props.bigday) && (cov_1jry2mt7kl().b[6][1]++, "padding-bottom: 0.75rem;");
}, function (props) {
  cov_1jry2mt7kl().f[4]++;
  cov_1jry2mt7kl().s[6]++;
  return (cov_1jry2mt7kl().b[7][0]++, props) && (cov_1jry2mt7kl().b[7][1]++, props.theme) && (cov_1jry2mt7kl().b[7][2]++, props.theme.calendar) && (cov_1jry2mt7kl().b[7][3]++, props.theme.calendar.borderColor);
}, function (props) {
  cov_1jry2mt7kl().f[5]++;
  cov_1jry2mt7kl().s[7]++;
  return (
    // show hover only if not disabled
    (cov_1jry2mt7kl().b[8][0]++, !props.disabled) && (cov_1jry2mt7kl().b[8][1]++, "\n        &:hover {\n          cursor: pointer;\n          background-color: ".concat((cov_1jry2mt7kl().b[9][0]++, props) && (cov_1jry2mt7kl().b[9][1]++, props.theme) && (cov_1jry2mt7kl().b[9][2]++, props.theme.calendar) && (cov_1jry2mt7kl().b[9][3]++, props.theme.calendar.selectedDayBgColor), ";\n        }\n      "))
  );
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      color: var(--textColor, #212121);\n      background-color: ", ";\n      padding: ", ";\n\n      ", ";\n\n      ", ";\n\n      ", ";\n\n      ", ";\n\n      ", ";\n    "])), function (props) {
  cov_1jry2mt7kl().f[6]++;
  cov_1jry2mt7kl().s[8]++;
  return (0, _get.default)(props, 'theme.contentBgColor', '#ffffff');
}, _themeMapper.evolutionTheme.calendar.day.padding, function (props) {
  cov_1jry2mt7kl().f[7]++;
  cov_1jry2mt7kl().s[9]++;
  return (
    // if disabled show a darker color
    (cov_1jry2mt7kl().b[10][0]++, props.disabled) && (cov_1jry2mt7kl().b[10][1]++, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n          color: var(--disableTextColor, #b2aebf);\n        "]))))
  );
}, function (props) {
  cov_1jry2mt7kl().f[8]++;
  cov_1jry2mt7kl().s[10]++;
  return (
    // in small view, hide sisable days
    (cov_1jry2mt7kl().b[11][0]++, props.disabled) && (cov_1jry2mt7kl().b[11][1]++, !props.bigday) && (cov_1jry2mt7kl().b[11][2]++, "\n        display:none;\n      ")
  );
}, function (props) {
  cov_1jry2mt7kl().f[9]++;
  cov_1jry2mt7kl().s[11]++;
  return (
    // show selected color
    (cov_1jry2mt7kl().b[12][0]++, props.selected) && (cov_1jry2mt7kl().b[12][1]++, props.bigday) && (cov_1jry2mt7kl().b[12][2]++, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n          background-color: var(--itemRowBgColor, rgba(254,1,107,0.05));\n          .stx-EventCalendar-ProductStickerWrapper .stx-ProductSticker {\n            background-color: ", ";\n          }\n        "])), (0, _get.default)(props, 'theme.contentBgColor', '#ffffff')))
  );
}, function (props) {
  cov_1jry2mt7kl().f[10]++;
  cov_1jry2mt7kl().s[12]++;
  return (cov_1jry2mt7kl().b[13][0]++, props.bigday) && (cov_1jry2mt7kl().b[13][1]++, "padding-bottom: 0.75rem;");
}, function (props) {
  cov_1jry2mt7kl().f[11]++;
  cov_1jry2mt7kl().s[13]++;
  return (
    // show hover only if not disabled
    (cov_1jry2mt7kl().b[14][0]++, !props.disabled) && (cov_1jry2mt7kl().b[14][1]++, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n          &:hover {\n            cursor: pointer;\n            background-color: var(--hoverBgColor, rgba(254,1,107,0.05));\n          }\n        "]))))
  );
}))));
var DayHeader = (cov_1jry2mt7kl().s[14]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: "g-calendar-day-header"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      ", "\n      ", "\n      ", "\n      padding: ", " ", " ", " ", ";\n      position: relative;\n    "])), function (props) {
  cov_1jry2mt7kl().f[12]++;
  cov_1jry2mt7kl().s[15]++;
  return (cov_1jry2mt7kl().b[15][0]++, props.bigday) && (cov_1jry2mt7kl().b[15][1]++, "\n        justify-content: space-between;\n      ");
}, function (props) {
  cov_1jry2mt7kl().f[13]++;
  cov_1jry2mt7kl().s[16]++;
  return (cov_1jry2mt7kl().b[16][0]++, props.disabled) && (cov_1jry2mt7kl().b[16][1]++, "color: ".concat((cov_1jry2mt7kl().b[17][0]++, props) && (cov_1jry2mt7kl().b[17][1]++, props.theme) && (cov_1jry2mt7kl().b[17][2]++, props.theme.calendar) && (cov_1jry2mt7kl().b[17][3]++, props.theme.calendar.selectedDayBgColor)));
}, function (props) {
  cov_1jry2mt7kl().f[14]++;
  cov_1jry2mt7kl().s[17]++;
  return (cov_1jry2mt7kl().b[18][0]++, !props.bigday) && (cov_1jry2mt7kl().b[18][1]++, "\n          background-color: ".concat((cov_1jry2mt7kl().b[19][0]++, props) && (cov_1jry2mt7kl().b[19][1]++, props.theme) && (cov_1jry2mt7kl().b[19][2]++, props.theme.calendar) && (cov_1jry2mt7kl().b[19][3]++, props.theme.calendar.smallDayHeaderBgColor), ";\n          color: ").concat((cov_1jry2mt7kl().b[20][0]++, props) && (cov_1jry2mt7kl().b[20][1]++, props.theme) && (cov_1jry2mt7kl().b[20][2]++, props.theme.calendar) && (cov_1jry2mt7kl().b[20][3]++, props.theme.calendar.smallDayHeaderTextColor), ";\n      "));
}, spacing.xxsmall, spacing.small, spacing.xxsmall, spacing.small)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      font-size: ", ";\n      font-weight: 500;\n      justify-content: flex-start;\n\n      position: relative;\n      ", "\n\n      @media (max-width: ", "px) {\n        background-color: unset;\n        width: auto;\n        height: auto;\n        border-radius: 0;\n        top: unset;\n        left: unset;\n      }\n\n      @media (max-width: ", "px) {\n        margin-bottom: 0;\n      }\n    "])), _themeMapper.evolutionTheme.typography.body2.fontSize, function (props) {
  cov_1jry2mt7kl().f[15]++;
  cov_1jry2mt7kl().s[18]++;
  return (cov_1jry2mt7kl().b[21][0]++, props.isToday) && (cov_1jry2mt7kl().b[21][1]++, "\n        background-color: var(--itemRowBgColor)};\n        width: 34px;\n        height: 34px;\n        border-radius: 9999px;\n        top: -5px;\n        left: -5px;\n      ");
}, _themeMapper.evolutionTheme.breakpoints.lg, _themeMapper.evolutionTheme.breakpoints.sm))));
var DayContent = (cov_1jry2mt7kl().s[19]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-calendar-day-content"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["", ""])), function (props) {
  cov_1jry2mt7kl().f[16]++;
  cov_1jry2mt7kl().s[20]++;
  return props.bigday ? (cov_1jry2mt7kl().b[22][0]++, "min-height: ".concat(spacing.xxlarge, ";")) : (cov_1jry2mt7kl().b[22][1]++, '');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n    position: relative;\n    ", "\n  "])), function (props) {
  cov_1jry2mt7kl().f[17]++;
  cov_1jry2mt7kl().s[21]++;
  return !props.isToday ? (cov_1jry2mt7kl().b[23][0]++, 'top: 8px; padding-bottom: 8px;') : (cov_1jry2mt7kl().b[23][1]++, '');
}))));
var DayIndicatorWrapper = (cov_1jry2mt7kl().s[22]++, _styledComponents.default.span(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  padding-top: ", ";\n"])), spacing.xsmall));
var DayIndicator = (cov_1jry2mt7kl().s[23]++, _styledComponents.default.div.attrs({
  className: 'g-calendar-day-indicator'
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  background-color: ", ";\n  padding: ", " ", " ", " ", ";\n  border-radius: ", ";\n  position: absolute;\n"])), function (props) {
  cov_1jry2mt7kl().f[18]++;
  cov_1jry2mt7kl().s[24]++;
  return (cov_1jry2mt7kl().b[24][0]++, props.theme) && (cov_1jry2mt7kl().b[24][1]++, props.theme.calendar) && (cov_1jry2mt7kl().b[24][2]++, props.theme.calendar.indicatorTextColor) || (cov_1jry2mt7kl().b[24][3]++, color.boxText);
}, function (props) {
  cov_1jry2mt7kl().f[19]++;
  cov_1jry2mt7kl().s[25]++;
  return (cov_1jry2mt7kl().b[25][0]++, props.theme) && (cov_1jry2mt7kl().b[25][1]++, props.theme.calendar) && (cov_1jry2mt7kl().b[25][2]++, props.theme.calendar.indicatorBgColor) || (cov_1jry2mt7kl().b[25][3]++, color.boxBackground);
}, spacing.xxsmall, spacing.small, spacing.xxsmall, spacing.small, spacing.small));
var DayDetails = (cov_1jry2mt7kl().s[26]++, (0, _styledComponents.default)(_gridStyled.Flex)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  justify-content: space-around;\n  flex-direction: column;\n  width: 100%;\n  top: 0px;\n  left: 0px;\n  text-align: center;\n"]))));
var DayFooter = (cov_1jry2mt7kl().s[27]++, _styledComponents.default.div.attrs({
  className: 'g-calendar-day-footer'
})(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)([""]))));
var DayBold = (cov_1jry2mt7kl().s[28]++, _styledComponents.default.div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: ", ";\n"])), font.weightBold));
var DayNumber = (cov_1jry2mt7kl().s[29]++, (0, _utils.withThemedStyles)(_styledComponents.default.span, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["font-size: ", ";"])), font.sizeXl)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n    ", "\n  "])), function (props) {
  cov_1jry2mt7kl().f[20]++;
  cov_1jry2mt7kl().s[30]++;
  return (cov_1jry2mt7kl().b[26][0]++, props.isToday) && (cov_1jry2mt7kl().b[26][1]++, "\n        font-size: ".concat(_themeMapper.evolutionTheme.typography.body2.fontSize, ";\n        width: 34px;\n        height: 34px;\n        text-align: center;\n        top: 5px;\n        position: absolute;\n      "));
}))));

/**
 * Day element of a calendar. Display the number of the day
 */
cov_1jry2mt7kl().s[31]++;
var Day = function Day(props) {
  cov_1jry2mt7kl().f[21]++;
  cov_1jry2mt7kl().s[32]++;
  return /*#__PURE__*/_react.default.createElement(BoxDay, {
    w: props.bigday ? (cov_1jry2mt7kl().b[27][0]++, 1 / 7) : (cov_1jry2mt7kl().b[27][1]++, 1),
    disabled: props.disabled,
    selected: props.selected,
    bigday: props.bigday,
    onClick: props.onClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 263,
      columnNumber: 3
    }
  }, /*#__PURE__*/_react.default.createElement(DayHeader, {
    bigday: props.bigday,
    isToday: (0, _utils2.isToday)(props.date),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 269,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(DayIndicatorWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 270,
      columnNumber: 7
    }
  }, (cov_1jry2mt7kl().b[28][0]++, props.indicator) && (cov_1jry2mt7kl().b[28][1]++, /*#__PURE__*/_react.default.createElement(DayIndicator, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 271,
      columnNumber: 29
    }
  }, props.indicator))), (cov_1jry2mt7kl().b[29][0]++, props.bigday) && (cov_1jry2mt7kl().b[29][1]++, /*#__PURE__*/_react.default.createElement(DayNumber, {
    isToday: (0, _utils2.isToday)(props.date),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 273,
      columnNumber: 24
    }
  }, (0, _get_date.default)(props.date))), (cov_1jry2mt7kl().b[30][0]++, !props.bigday) && (cov_1jry2mt7kl().b[30][1]++, /*#__PURE__*/_react.default.createElement(DayDetails, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 275,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(DayBold, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 276,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
    weekday: "long",
    value: props.date,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 277,
      columnNumber: 13
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 279,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    value: props.date,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 280,
      columnNumber: 13
    }
  }))))), (cov_1jry2mt7kl().b[31][0]++, !((cov_1jry2mt7kl().b[32][0]++, props.selected) && (cov_1jry2mt7kl().b[32][1]++, !props.bigday))) && (cov_1jry2mt7kl().b[31][1]++, /*#__PURE__*/_react.default.createElement(DayContent, {
    bigday: props.bigday,
    isToday: (0, _utils2.isToday)(props.date),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 286,
      columnNumber: 7
    }
  }, props.content)), (cov_1jry2mt7kl().b[33][0]++, !props.selected) && (cov_1jry2mt7kl().b[33][1]++, /*#__PURE__*/_react.default.createElement(DayFooter, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 288,
      columnNumber: 25
    }
  }, props.footer)));
};
cov_1jry2mt7kl().s[33]++;
Day.propTypes = {
  /** The date representing the day */
  date: _propTypes.default.instanceOf(Date).isRequired,
  /** The content of the day */
  content: _propTypes.default.node,
  /** The footer of the day */
  footer: _propTypes.default.node,
  /** An indicator displayed on the top left */
  indicator: _propTypes.default.node,
  /** boolean indicator to ensure that there is a min height on the days */
  bigday: _propTypes.default.bool,
  /** Display a grey background if disabled */
  disabled: _propTypes.default.bool,
  /** If day is selected, highlight it */
  selected: _propTypes.default.bool,
  /** provide a function that should be handled on click */
  onClick: _propTypes.default.func
};
cov_1jry2mt7kl().s[34]++;
Day.defaultProps = {
  content: '',
  footer: '',
  indicator: undefined,
  bigday: false,
  disabled: false,
  selected: false,
  onClick: undefined
};
var _default = exports.default = Day;